module.exports = __webpack_public_path__ + "static/media/Inter-Regular.a4a73795.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Inter/Inter-Regular.ttf
// module id = 2890
// module chunks = 0